export const wrapper = {
	display: 'block',
	width: '100%',
	height: '100%',
	'div > .swiper-wrapper > .swiper-slide': {
		marginRight: '1rem',
	},
	'.swiper-pagination-bullet': {
		backgroundColor: 'white !important',
	},
	'.swiper-pagination-bullet-active': {
		backgroundColor: '#004BB9 !important',
	},
	'& .swiper-button-prev, & .swiper-button-next': {
		color: 'text.interactive',
	},
};

export const getSwiperStyles = {
	paddingBottom: '2rem',
};
